import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, Input, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
@Component({
  selector: 'expo-button',
  templateUrl: './expo-button.component.html',
  styleUrls: ['./expo-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    MatRippleModule
  ],
  animations: [
    trigger('disappear', [
      transition(':leave', [
        animate(600, style({
          opacity: 0,
          transform: 'scale(0) translate(350px, -450px)',
          width: 0
        })),
      ]),
    ])
  ]
})
export class ExpoButtonComponent implements OnInit {
  @Input()
  reverseHighlight = false;

  @Input()
  animate: boolean;

  @Input() disabled = false;

  @HostBinding("@disappear")
  get disappear() {
    return true;
  }


  mouseOver: boolean;

  constructor(
  ) { }

  ngOnInit(): void {
  }

  mouseEnter(): void {
    this.mouseOver = true;
  }

  mouseLeave(): void {
    this.mouseOver = false;
  }
}
